import { render } from "./SelectRegion.vue?vue&type=template&id=8240ba18&scoped=true"
import script from "./SelectRegion.vue?vue&type=script&lang=js"
export * from "./SelectRegion.vue?vue&type=script&lang=js"

import "./SelectRegion.vue?vue&type=style&index=0&id=8240ba18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8240ba18"]])

export default __exports__